import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Text } from 'roo-ui/components';
import { useDialog } from 'components/Dialog';
import { getInventoryUnavailableErrors, getProperty } from 'store/booking/bookingSelectors';
import ErrorHeading from 'pages/Checkout/BookingErrorDialogs/ErrorHeading';
import { useDataLayer } from 'hooks/useDataLayer';

const InventoryUnavailableDialog = () => {
  const { Dialog, isOpen, openDialog, closeDialog } = useDialog();
  const inventoryUnavailableErrors = useSelector(getInventoryUnavailableErrors);
  const property = useSelector(getProperty);
  const { emitInteractionEvent } = useDataLayer();

  const hasErrors = !!inventoryUnavailableErrors.length;

  useEffect(() => {
    if (hasErrors) {
      openDialog();
      emitInteractionEvent({ type: 'Booking Errors', value: 'Inventory Unavailable Error Showed' });
    }
    if (!hasErrors) closeDialog();
  }, [isOpen, openDialog, closeDialog, hasErrors, emitInteractionEvent]);

  const handleChangeClick = () => {
    window.history.back();
  };

  if (!hasErrors) return null;

  return (
    <Dialog>
      <ErrorHeading>Sorry, your selection is no longer available</ErrorHeading>
      <Text display="block" mb={6} data-testid="message">
        Please change your selection at {property?.name} to continue with your booking.
      </Text>
      <Button variant="inverted" width={['100%', 'auto']} onClick={handleChangeClick}>
        Change selection
      </Button>
    </Dialog>
  );
};

InventoryUnavailableDialog.displayName = 'InventoryUnavailableDialog';

export default InventoryUnavailableDialog;
